/**
 * Explicit playback of remote call media. `autoPlay` alone fails silently on
 * Android WebView / iOS in-app browsers (mediaPlaybackRequiresUserGesture):
 * the stream arrives seconds after the user's tap, the implicit play() is
 * rejected and the user is left in silence with billing running.
 */
export type RemotePlayResult = 'playing' | 'blocked' | 'ignored';

/**
 * play() and classify the outcome:
 * - 'playing'  → audio flowing, nothing to do
 * - 'blocked'  → NotAllowedError: autoplay policy, needs a user gesture
 *                (show the unlock banner)
 * - 'ignored'  → transient failure (AbortError on re-render/unmount, etc.):
 *                never show UI for these
 */
export async function playRemoteMedia(el: HTMLMediaElement): Promise<RemotePlayResult> {
  try {
    await el.play();
    return 'playing';
  } catch (err) {
    if ((err as DOMException)?.name === 'NotAllowedError') {
      console.error('[CALL] Remote media autoplay blocked, showing unlock banner');
      return 'blocked';
    }
    return 'ignored';
  }
}
